(function () {
    'use strict';

    angular
        .module('app')
        .controller('editableFields', editableFields);

    editableFields.$inject = ['editableFieldsService', '$mdDialog', '$filter', 'loginService'];

    function editableFields(editableFieldsService, $mdDialog, $filter, loginService) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'editableFields';

        vm.editableFieldsLabel = loginService.resourceStrings["EDITABLE_FIELDS"]; // "Editable Fields"
        vm.userFieldsLabel = loginService.resourceStrings["USER_FIELDS"]; // "User Fields"
        vm.okLabel = loginService.resourceStrings["OK"]; // "OK"
        vm.cancelLabel = loginService.resourceStrings["CANCEL"]; // "Cancel"

        vm.notEditableSelected = [];
        vm.editableSelected = [];
        vm.changed = false;
        activate();
        vm.editableFieldsService = editableFieldsService;
        vm.loadingDataLabel = "Loading Data"
        editableFieldsService.getEditableFields().then(function () {
        });


        //when the ok button is clicked
        vm.onOk = function () {
            //set the fields
            editableFieldsService.setEditableFields(editableFieldsService.editableFields).then(function () {
                $mdDialog.hide();
            })          
        }

        //when the cancel button is clicked
        vm.onCancel = function () {
            $mdDialog.cancel();
        }


        //handles the click event for both lists
        vm.itemClicked = function (item, event) {
            //if the control key was not pressed unselect all other items otherwise leave them selected
            if (!event.ctrlKey) {
                angular.forEach(editableFieldsService.notEditableFields, function (thisItem) {
                    if (item.fieldName != thisItem.fieldName) {
                        thisItem.selected = false;
                    }                 
                });

                angular.forEach(editableFieldsService.editableFields, function (thisItem) {
                    if (item.fieldName != thisItem.fieldName) {
                        thisItem.selected = false;
                    }
                });
            }
            
            item.selected = !item.selected;
            
            //store the selected items in a variable
            vm.notEditableSelected = $filter('filter')(editableFieldsService.notEditableFields, { selected: true });
            vm.editableSelected = $filter('filter')(editableFieldsService.editableFields, { selected: true });
        }


        //when moving items to editable
        vm.moveToEditable = function () {
            vm.changed = true;
            angular.forEach(vm.notEditableSelected, function (item) {
                var index = editableFieldsService.notEditableFields.indexOf(item);
                editableFieldsService.editableFields.push(item);
                editableFieldsService.notEditableFields.splice(index, 1);
                item.selected = false;
               
            });
            vm.editableSelected = [];
            vm.notEditableSelected = [];
        }

        //when moving items to noteditable
        vm.moveToNotEditable = function () {
            vm.changed = true;
            angular.forEach(vm.editableSelected, function (item) {
                var index = editableFieldsService.editableFields.indexOf(item);
                editableFieldsService.notEditableFields.push(item);
                editableFieldsService.editableFields.splice(index, 1);
                item.selected = false;
            });
            vm.editableSelected = [];
            vm.notEditableSelected = [];
        }


        //handles moving all items to editable
        vm.moveAllToEditable = function () {
            vm.changed = true;
            angular.forEach(editableFieldsService.notEditableFields, function (item) {
                var index = editableFieldsService.notEditableFields.indexOf(item);
                editableFieldsService.editableFields.push(item);
                item.selected = false;
            });
            vm.editableSelected = [];
            vm.notEditableSelected = [];
            editableFieldsService.notEditableFields = [];
        }

        //handles moving all items to noteditable
        vm.moveAllToNotEditable = function () {
            vm.changed = true;
            angular.forEach(editableFieldsService.editableFields, function (item) {
                var index = editableFieldsService.editableFields.indexOf(item);
                editableFieldsService.notEditableFields.push(item);
                item.selected = false;
            });
            vm.editableSelected = [];
            vm.notEditableSelected = [];
            editableFieldsService.editableFields = [];
        }


        function activate() { }
    }
})();
